import axios from "axios";
import { ProgressSpinner } from "primereact/progressspinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
export const companyID = "1";

// Base URL for API requests
// export const axiosapibaseurl = "http://localhost:8095/";
//export const axiosapibaseurl = "http://192.168.1.204:8095/";
 export const axiosapibaseurl = "https://tv.hap.in/";
// PRD URL for PI Request
//export const axiosapibaseurl = "http://18.139.103.185:5000/";
// Initial token values fetched from localStorages
export const JWTTokenValue = localStorage.getItem("JWtAccessToken");
const refreshtoken = localStorage.getItem("JWTRefreshToken");
// S3 URL for file storage
export const s3url = "https://hapbusinessportal.s3.ap-south-1.amazonaws.com/";
// Axios headers for basic authentication
export const axiosDTVbasicAuthForm = {
  headers: {
    Authorization: `Bearer ${JWTTokenValue}`,
    "Content-Type": "multipart/form-data", // Modify content type as needed
  },
};
const getJWTToken = () => localStorage.getItem("JWtAccessToken");
const getRefreshToken = () => localStorage.getItem("JWTRefreshToken");
// Function to get authorization headers with JWT token
const getAuthorizationHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("JWtAccessToken")}`,
    "Content-Type": "application/json",
  },
});

const axiosInstance = axios.create({ baseURL: axiosapibaseurl });

let isRefreshing = false;
let refreshSubscribers = [];

// Function to add subscribers for refresh token requests
const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

// Notify all subscribers with new token
const onRrefreshed = (token) => {
  refreshSubscribers.map((cb) => cb(token));
  refreshSubscribers = [];
};

// **Function to Refresh Token**
const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      subscribeTokenRefresh((token) => {
        resolve(token);
      });
    });
  }

  isRefreshing = true;

  try {
    const refreshToken = getRefreshToken();
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post(
      `${axiosapibaseurl}api/LoginJwt/RefreshTokens`,
      {
        token: getJWTToken(),
        refreshToken: refreshToken,
      }
    );

    if (response.data.Token) {
      localStorage.setItem("JWtAccessToken", response.data.Token);
      onRrefreshed(response.data.Token);
      return response.data.Token;
    } else {
      throw new Error("Invalid refresh token response");
    }
  } catch (error) {
    console.error("Refresh token failed:", error);
    logoutUser();
    return null;
  } finally {
    isRefreshing = false;
  }
};

// **Logout Function**
const logoutUser = () => {
  localStorage.removeItem("JWtAccessToken");
  localStorage.removeItem("JWTRefreshToken");
  localStorage.removeItem("logginuser");
  window.location.href = "/login"; // Redirect to login page
};

// **Axios Request Interceptor**
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getJWTToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// **Axios Response Interceptor**
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const newToken = await refreshAccessToken();
      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      }
    }

    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401)
    ) {
      logoutUser();
    }

    return Promise.reject(error);
  }
);

// **POST API Call**
export const postAPICall = async (endpointURL, paramdata) => {
  try {
    return await axiosInstance.post(endpointURL, paramdata);
  } catch (error) {
    console.error("API Call Error:", error);
  }
};

// **PUT API Call**
export const putAPICall = async (endpointURL, paramdata) => {
  try {
    return await axiosInstance.put(endpointURL, paramdata);
  } catch (error) {
    console.error("API Call Error:", error);
  }
};

// **DELETE API Call**
export const DeleteAPICall = async (endpointURL, paramdata) => {
  try {
    return await axiosInstance.delete(endpointURL, { data: paramdata });
  } catch (error) {
    console.error("API Call Error:", error);
  }
};
// Function to convert date and time strings to a specific format
export const convertDateTimeCLSS = (str) => {
  const date = new Date(str);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
// tostref get value in   commponent
let toastRef = null;
export const setToastRef = (ref) => {
  toastRef = ref;
};
//Function to display notifications
export const showToast = (
  severity,
  summary,
  detail,
  life = 3000,
  width = "auto",
  height = "auto",
  className = "green-toast"
) => {
  if (toastRef) {
    toastRef.show({
      severity,
      summary,
      detail,
      life,
      className,
      width,
      height,
    });
  }
};
export const errorToast = (
  severity,
  summary,
  detail,
  width = "auto",
  height = "auto",
  life = 3000,
  className = "red-toast"
) => {
  if (toastRef) {
    toastRef.show({
      severity,
      summary,
      detail,
      life,
      className,
      width,
      height,
    });
  }
};

//spinner

export const GlobalSpinner = ({ loading }) => {
  return loading ? (
    <div className="global-spinner-overlay">
      <ProgressSpinner
        className="global-spinner"
        style={{ width: "50px", height: "30px", marginTop: "250px" }}
        strokeWidth="3"
      />
    </div>
  ) : null;
};
export const removeLeadingNumberAndDash = (text) => {
  return text.replace(/^\d+ -\s*/, "");
};
export const removeLeadingTextAndDash = (text) => {
  const match = text.match(/^\d+/); // Match leading numbers
  return match ? match[0] : ""; // Remove leading number and dash
};
export const isAuthenticated = () => {
  return localStorage.getItem("logginuser") !== null; // Check if the user is logged in
};
export const showSuccessToast = (message) => toast.success(message);
export const showErrorToast = (message) => toast.error(message);
export const showLoadingToast = (message) => toast.loading(message);
export const dismissToast = (toastId) => toast.dismiss(toastId);
